import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Home from './components/Home';
import Footer from './components/Footer';
import Header from './components/Header';
import { Routes, Route } from 'react-router-dom';
import Info from './components/Info';

export default function App() {   
  return (   
        <>
            <Header/>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/info" element={<Info />} />                
            </Routes>
            <Footer/>
        </>
  );
}

